import type { TenantConfig } from '@/shared/providers/tenantConfig';
import { KEILOG_BRAND } from '../../constants/brand';

/**
 * Keilog tenant config — feature flags and locale settings.
 * Counterpart of the backend's `app/Tenants/Keilog/Config/tenant.php`.
 */
export const keilogConfig: TenantConfig = {
  name: 'KEiLOG',
  code: 'keilog',
  description: 'KEiLOG Medical Clinic System',
  enabled: true,
  theme: {
    primaryColor: KEILOG_BRAND.brand,
    secondaryColor: KEILOG_BRAND.accent,
    backgroundColor: KEILOG_BRAND.canvas,
    textColor: KEILOG_BRAND.inkBody,
    logo: '/images/keilog/keilog_icon.png',
    favicon: '/images/keilog/keilog_favicon.png',
  },
  features: {
    patients: true,
    consents: true,
    rezepts: true,
    visits: true,
    /*
     * Keep in step with `VITE_SSO_UNIFIED_PORTAL_PATHS` and with
     * `sso_tenant_routes.portal_mode` in the database —
     * `resolvePublicPortalProfile` returns `invalid` the moment they disagree,
     * and the login screen renders a configuration error instead of a form.
     */
    unifiedPortal: true,
    adminSsoMapping: false,
    partitionClinicRoutesByServiceType: false,
    recoverStaleSessionHydrationViaPassiveSso: true,
  },
  settings: {
    dateFormat: 'YYYY年MM月DD日',
    currency: '円',
    language: 'ja',
    siteTypeLabel: 'KEiLOG',
    siteTypeShortCode: 'KLG',
    clinicNumber: {
      maxLength: 20,
      numericOnly: false,
    },
    insurerDialogContact: {
      phone: '',
      department: 'システム管理者',
      separateWarningContactLine: true,
    },
    serviceLinks: {
      // Build-time environment ownership keeps every deployment's public
      // hostname out of source. Consumers validate this again before rendering.
      // `import.meta.env` is optional-chained because this module is also read
      // by `vite.config.ts` (favicon boot map), where it does not exist.
      keilog: import.meta.env?.VITE_KEILOG_PORTAL_URL?.trim() || '',
    },
  },
};
